module.exports = __webpack_public_path__ + "static/media/logo_pie@2x.d6b7bdcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo_pie@2x.png
// module id = 92
// module chunks = 0